var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 62.842",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Redo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-redo",
    "data-name": "Icon ionic-ios-redo",
    d: "M2.25,68.467h.518a.775.775,0,0,0,.732-.5A38.824,38.824,0,0,1,7.32,60.88c3.838-5.838,10.426-12.033,16.871-14.907a41.7,41.7,0,0,1,17.335-4.142.714.714,0,0,1,.75.714V57.113a.722.722,0,0,0,1.107.607L81.929,32.333a.717.717,0,0,0,0-1.2L43.366,5.749a.709.709,0,0,0-1.107.607V21.1a.709.709,0,0,1-.678.714C28.8,22.5,19.6,26.245,12.408,33.511c-10.89,11-10.141,24.834-10.141,28.333C2.268,63.683,2.25,66.361,2.25,68.467Z",
    transform: "translate(-2.25 -5.625)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedo);
export default __webpack_public_path__ + "static/media/redo.0d79378503b3020558282aadf1012b53.svg";
export { ForwardRef as ReactComponent };